"use client";
import { memo, type CSSProperties, type ReactElement } from "react";
import type { MotionValue } from "framer-motion";
import type { ContainerPreset } from "@/constants/componentPresets";
import type { TeamData } from "../Cteamcard";
import { CarouselCard } from "./CarouselCard";
import { CarouselPlaceholderSlot } from "./CarouselPlaceholderSlot";
import { getCyclicDistance } from "./carouselMath";
import { TEAM_CARD_RENDER_RADIUS } from "./constants";
import type { CarouselTeamSelectInput } from "./types";
interface CarouselCardStripProps {
    cardContainerPreset?: ContainerPreset;
    cardGap: number;
    cardHeight: number;
    cardWidth: number;
    centeredDoubledIndex: number;
    entranceReady: boolean;
    handleScrollToIndex: (doubledIndex: number) => void;
    handleSelectTeam: (input: CarouselTeamSelectInput) => void;
    isMobile: boolean;
    items: TeamData[];
    pitch: number;
    scrollX: MotionValue<number>;
    spacerStyle: CSSProperties;
    vendorsByTeamId: Map<string, string[]>;
}
export const CarouselCardStrip = memo(function CarouselCardStrip({ cardContainerPreset, cardGap, cardHeight, cardWidth, centeredDoubledIndex, entranceReady, handleScrollToIndex, handleSelectTeam, isMobile, items, pitch, scrollX, spacerStyle, vendorsByTeamId, }: CarouselCardStripProps): ReactElement {
    const itemsLength = items.length;
    return <>
            <div style={spacerStyle} aria-hidden="true"/>

            {items.map((team, index) => {
            const distanceInDoubledList = getCyclicDistance({
                firstIndex: index,
                secondIndex: centeredDoubledIndex,
                mod: itemsLength,
            });
            const isWithinRenderRadius = distanceInDoubledList <= TEAM_CARD_RENDER_RADIUS;
            if (!isWithinRenderRadius) {
                return (<CarouselPlaceholderSlot key={`placeholder-${team.id}-${index}`} cardWidth={cardWidth} cardHeight={cardHeight} cardGap={cardGap} cardContainerPreset={cardContainerPreset}/>);
            }
            return (<CarouselCard key={`${team.id}-${index}`} team={team} doubledIndex={index} scrollX={scrollX} pitch={pitch} cardWidth={cardWidth} cardHeight={cardHeight} cardGap={cardGap} cardContainerPreset={cardContainerPreset} distanceFromCenter={distanceInDoubledList} entranceReady={entranceReady} isMobile={isMobile} isCentered={distanceInDoubledList === 0} onSelectTeam={handleSelectTeam} onScrollToIndex={handleScrollToIndex} precomputedVendors={vendorsByTeamId.get(team.id)}/>);
        })}

            <div style={spacerStyle} aria-hidden="true"/>
        </>
        ;
});
